var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-nav"},[_c('nav',{staticClass:"main-nav__wrapper"},[_c('SiteMenu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }